import axios from "@/axiosDod.js";

const fetchEmployeeStatuses = async ({ commit }) => {
  const response = await axios.get("employees/statuses");
  if (response.data) {
    commit("SET_EMPLOYEE_STATUSES", response.data.data);
  }
};

const fetchCustomerStatuses = async ({ commit }) => {
  const response = await axios.get("customers/statuses");
  if (response.data) {
    commit("SET_CUSTOMER_STATUSES", response.data.data);
  }
};

const setSelectedCustomerStatus = async ({ commit }, status) => {
  commit("SET_SELECTED_CUSTOMER_STATUS", status)
}

const setSelectedEmployeeStatus = async ({ commit }, status) => {
  commit("SET_SELECTED_EMPLOYEE_STATUS", status)
}

const setSelectedLeftBarLink = async ({ commit }, link) => {
  commit("SET_SELECTED_LEFT_BAR_LINK", link)
}


const fetchStatusesCounters = async ({ commit }) => {
  const customerStatuses = await axios.get("customers/countersByStatus")
  const employeeStatuses = await axios.get("employees/countersByStatus")
  const tasksCounter = await axios.get("tasks/countersActive")
  const statuses = [...customerStatuses.data, ...employeeStatuses.data, { status: "Zadania", counter: tasksCounter.data }]
  let result = {}
  statuses.forEach(counter => {
    result[counter.status] = counter.counter
  })
  commit("SET_STATUSES_COUNTERS", result)
}

export default {
  fetchEmployeeStatuses,
  fetchCustomerStatuses,
  setSelectedCustomerStatus,
  setSelectedEmployeeStatus,
  setSelectedLeftBarLink,
  fetchStatusesCounters
};
